import type { SourceSummary } from '../services/api';

/** Mapa nome exibido → agency key (catálogo `/sources/summary`). */
export function buildAgencyNameToKeyMap(summaries: SourceSummary[]): Map<string, string> {
  const map = new Map<string, string>();
  for (const row of summaries) {
    const name = (row.name || '').trim();
    const key = (row.key || '').trim();
    if (name && key && !map.has(name)) {
      map.set(name, key);
    }
  }
  return map;
}

export function resolveAgencyKeysFromNames(
  names: string[],
  nameToKey: Map<string, string>,
): string[] {
  const keys: string[] = [];
  const seen = new Set<string>();
  for (const name of names) {
    const key = nameToKey.get(name.trim());
    if (key && !seen.has(key)) {
      seen.add(key);
      keys.push(key);
    }
  }
  return keys.sort((a, b) => a.localeCompare(b, 'pt-BR'));
}
